import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const employeeRoutesDictionary = moduleRouteDictionaryFactory(
  'employees',
  'employees',
  {
    list: 'list',
    create: 'create',
    detail: 'detail/:id',
    creditsDetail: 'detail/:id/credits/:year',
    editAnagraphic: 'edit/:id/anagraphic',
    editCompany: 'edit/:id/company',
    inviteMany: 'invite-many',
    massiveEmployeeDeactivation: 'massive-employee-deactivation',
  },
);

export const subscriptionRoutesDictionary = moduleRouteDictionaryFactory(
  'subscriptions',
  'subscriptions',
  {
    list: 'list',
    deactivated: 'deactivated',
  },
);
